import { oneOfType, string, number, bool } from 'prop-types';

/**
 * The base prop types for both the internal and external component.
 * @type {Object}
 */
export const BASE_PROP_TYPES = {
    children: oneOfType([
        string,
        number
    ]).isRequired,
    value: oneOfType([
        string,
        number
    ]),
    disabled: bool
};

/**
 * The base default prop types for both the internal and external component.
 * @type {Object}
 */
export const BASE_DEFAULT_PROPS = {
    disabled: false
};
